import React from "react"
import {
  Card,
  Col,
  Row,
  CardBody,
  Label,
  Form,
  Input,
  FormFeedback,
  Button,
  Table,
} from "reactstrap"

import { useFormik } from "formik"
import * as Yup from "yup"
import toast from "react-hot-toast"
import { Link, useNavigate } from "react-router-dom"
import Spinners from "components/Common/Spinner"
import {
  useCreateInvestorUserMutation,
  useUpdateInvestorUserMutation,
} from "store/api/investorapi/user.api"
import { investorPermissions } from "helpers/investorPermissions"
import list from "../../../assets/images/icons/list.svg"

const UsersInvestorForm = ({ defaultValues, id = null, userStatus = null }) => {
  const [createUser, { isLoading }] = useCreateInvestorUserMutation()
  const [updateUser, { isLoading: isUpdating }] =
    useUpdateInvestorUserMutation()
  const history = useNavigate()

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { ...defaultValues },
    validationSchema: Yup.object({}),
    onSubmit: async (values) => {
      if (id) await onUpdateUser(values)
      else await onCreateUser(values)
    },
  })

  const onCreateUser = async (values) => {
    try {
      const { data, message, success } = await createUser(values).unwrap()
      if (success) {
        history("/manage-users")
        toast.success(message, { id: "submitSuccess" })
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const onUpdateUser = async (values) => {
    try {
      const { data, message, success } = await updateUser({
        id,
        ...values,
      }).unwrap()
      if (success) {
        history("/manage-users")
        toast.success(message, { id: "submitSuccess" })
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }

      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  return (
    <React.Fragment>
      <Row>
        <Col xl={12}>
          <Card>
            <CardBody>
              <Form
                className="form-horizontal"
                onSubmit={(e) => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >
                <Row className="mb-2">
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Name <span className="error">*</span>
                    </Label>
                    <Input
                      name="name"
                      className="form-control"
                      placeholder="Enter Name"
                      type="text"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.name || ""}
                      invalid={
                        validation.touched.name && validation.errors.name
                          ? true
                          : false
                      }
                    />
                    {validation.touched.name && validation.errors.name ? (
                      <FormFeedback type="invalid">
                        {validation.errors.name}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Col xl={6}>
                    <Label className="col-form-label">
                      Email Address<span className="error">*</span>
                    </Label>
                    <Input
                      name="email"
                      className="form-control"
                      placeholder="Enter Email Address"
                      type="text"
                      disabled={userStatus}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.email || ""}
                      invalid={
                        validation.touched.email && validation.errors.email
                          ? true
                          : false
                      }
                    />
                    {validation.touched.email && validation.errors.email ? (
                      <FormFeedback type="invalid">
                        {validation.errors.email}
                      </FormFeedback>
                    ) : null}
                  </Col>

                  <Col xl={12}>
                    <hr />
                    <h5>Permissions</h5>
                    <hr />
                    <div
                      className={`${
                        validation.touched.permissions &&
                        validation.errors.permissions &&
                        "is-invalid"
                      }`}
                    >
                      <div className="table-bordered-wrapper user-role-table">
                        <div className={"table-responsive"}>
                          <Table hover>
                            <thead>
                              <tr>
                                <th>Module</th>
                                <th>
                                  <div className="d-flex align-items-center justify-content-center gap-2">
                                    <img src={list} alt="" /> Pemisisons
                                  </div>
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {investorPermissions.map((permission, index) => (
                                <tr key={`investorPermissions_${index}`}>
                                  <td>{permission.label}</td>
                                  <td>
                                    <div className="gap-2 d-flex flex-column">
                                      {permission.items.map((item, j) => (
                                        <div
                                          key={`investorPermissions_${index}_${j}`}
                                        >
                                          {item.key === "HR" ? (
                                            <div
                                              style={{
                                                marginBlock: "10px",
                                                height: "1px",
                                                background: "#ddd",
                                                width: "50%",
                                              }}
                                            />
                                          ) : (
                                            <div className="d-flex gap-2">
                                              <input
                                                type="checkbox"
                                                name="permissions"
                                                id={item.key}
                                                value={item.key}
                                                className="form-check-input"
                                                onChange={(e) => {
                                                  const { checked, value } =
                                                    e.target
                                                  const newPermissions = checked
                                                    ? [
                                                        ...validation.values
                                                          .permissions,
                                                        value,
                                                      ]
                                                    : validation.values.permissions.filter(
                                                        (v) => v !== value
                                                      )
                                                  validation.setFieldValue(
                                                    "permissions",
                                                    newPermissions
                                                  )
                                                }}
                                                onBlur={validation.handleBlur}
                                                checked={validation.values.permissions.includes(
                                                  item.key
                                                )}
                                              />
                                              <label
                                                style={{ margin: 0 }}
                                                htmlFor={item.key}
                                              >
                                                {item.label}
                                              </label>
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </div>

                    {validation.touched.permissions &&
                    validation.errors.permissions ? (
                      <FormFeedback type="invalid">
                        {validation.errors.permissions}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </Row>
                <Row className="justify-content-end mt-4">
                  <Col sm={12}>
                    <div className="d-flex justify-content-end align-items-center gap-3">
                      <Link
                        to={"/users"}
                        type="button"
                        className="btn btn-cancel w-md"
                      >
                        Cancel
                      </Link>
                      <Button
                        type="submit"
                        className="btn btn-primary w-md"
                        disabled={isLoading || isUpdating}
                      >
                        {isLoading || isUpdating ? (
                          <Spinners />
                        ) : !id ? (
                          `Create User`
                        ) : (
                          "Update User"
                        )}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default UsersInvestorForm
